<script>
import router from "@/router";
import {mapGetters} from "vuex";
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import {findSkeletonToken} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Skeleton";

export default {
  name: "ChatsWrapper",
  props: {
    slicer: {
      default: Infinity,
    },
    allChats: { // if we set it true we get all chats from dashboard and we must be admin
      default: false
    }
  },
  data() {
    return {
      current_page: 1,
      chats: [],
      paginationMeta: [],
      un_read_chats: 0,
    }
  },
  computed: {
    ...mapGetters({
      filters: 'Chat/getFilters',
      userId: 'User/getUserId',
      isAuthenticated: 'User/isAuthenticated',
    }),
  },
  methods: {
    async changePage(page) {

      this.current_page = page

      await this.setChats(page)

      this.$emit("current_page", page);
    },
    setPerPage() {
      this.$store.commit("Chat/setFilters", {key: "per_page", value: this.perPage})
    },
    async setChats(page = 1) {

      let response = []

      if (this.allChats) {
        response = await this.$store.dispatch("Chat/getChats", page);
      } else {

        let form = {
          user_id: this.userId,
          page: this.current_page
        }

        if (this.isAuthenticated) {
          response = await this.$store.dispatch("Chat/getUserChats", form);
        } else {
          form.user_id = localStorage.getItem('chat_token')
          response = await this.$store.dispatch("Chat/getUserChatsWithToken", form);
        }

      }


      let data = response.data.data

      this.chats = data.data
      this.paginationMeta = data.meta
      this.un_read_chats = data.un_read_chats
      this.$emit("chats", this.chats);
      this.$emit("rawChatData", data);

    },
    async initWrapper() {

      await this.setChats()

    }
  },
  render() {
    return this.$slots.default({
      chats: this.chats.slice(0, this.slicer),
      pagination: this.paginationMeta,
      changePageFunction: this.changePage,
      current_page: this.current_page,
      un_read_chats: this.un_read_chats
    });
  },
  async mounted() {
    await this.initWrapper();
  },
}
</script>
